import React from "react";
import { CelligenceFooter } from "footer-component";
import { Container, Row, Col } from "react-bootstrap"; // Assuming you are using react-bootstrap
import "./index.css";

const CustomFooter = ( ) => {
 
  return (
    <>
      <footer >
          <Container>
            <CelligenceFooter type="celligence" />
          </Container>
      </footer>
    </>
  );
};

export default CustomFooter;